import YYIcon from './icon'

export default YYIcon